import React from "react";
import { useReducer } from "react";
import checkIcon from "../../../Assets/Icons/checkIcon.svg";

import "./style.css";

const CheckBox = ({
  toggle,
  stateProp,
  label,
  className,
  labelClassName,
  text = "Checkbox",
  onChange,
}) => {
  const [state, dispatch] = useReducer(reducer, {
    toggle: toggle || false,
    state: stateProp || "default",
    label: label || true,
  });

  const handleClick = () => {
    dispatch("click");
    // Call the onChange function with the current toggle state
    onChange && onChange(text);
  };

  return (
    <div
      className={`check-box ${state.state} toggle-${state.toggle} ${className}`}
      onMouseLeave={() => {
        dispatch("mouse_leave");
      }}
      onMouseEnter={() => {
        dispatch("mouse_enter");
      }}
      onClick={handleClick} // Use the handleClick function
    >
      {state.state === "default" && !state.toggle && (
        <div className={`checkbox checkbox-variant`} />
      )}

      {(state.state === "hover" ||
        (state.toggle && state.state === "default")) && (
        <div className="div">
          {state.toggle && (
            <div className="interface-essential">
              <img className="done-check" src={checkIcon} alt="Checked" />
            </div>
          )}
        </div>
      )}

      <div className={`label ${labelClassName}`}>{text}</div>
    </div>
  );
};

function reducer(state, action) {
  if (
    state.label === true &&
    state.state === "hover" &&
    state.toggle === false
  ) {
    switch (action) {
      case "click":
        return {
          label: true,
          state: "default",
          toggle: true,
        };
    }
  }

  if (
    state.label === true &&
    state.state === "hover" &&
    state.toggle === true
  ) {
    switch (action) {
      case "click":
        return {
          label: true,
          state: "default",
          toggle: false,
        };
    }
  }

  switch (action) {
    case "mouse_enter":
      return {
        ...state,
        state: "hover",
      };

    case "mouse_leave":
      return {
        ...state,
        state: "default",
      };
  }

  return state;
}

export default CheckBox;
